interface TabPanelProps {
  children: React.ReactNode;
  panelValue: string;
  value: string;
}
const TabPanel = ({ value, panelValue, children }: TabPanelProps) => {
  return (
    <div
      role="tabpanel"
      style={{ width: '100%', height: '100%' }}
      hidden={value !== panelValue}
      id={`simple-tabpanel-${panelValue}`}
      aria-labelledby={`simple-tab-${panelValue}`}
    >
      {value === panelValue && <>{children}</>}
    </div>
  );
};

export default TabPanel;
